module.exports = __webpack_public_path__ + "static/media/Favorites.426ad109.svg";